import styled from "styled-components";

export const StyledStatistics = styled("section")(
  ({ theme }) => `
  padding: 64px 20px;
  border-top: 1px solid ${theme.colorBorder};
  border-bottom: 1px solid ${theme.colorBorder};
  background: ${theme.colorBgContainer};
`,
);

export const StatCard = styled("div")`
  text-align: center;
`;

export const StatValue = styled("h2")(
  ({ theme }) => `
  color: ${theme.colorPrimary};
  font-weight: 800;
  margin-bottom: 4px;
  font-size: 36px;
`,
);

export const StatLabel = styled("p")(
  ({ theme }) => `
  color: ${theme.colorTextSecondary};
  font-size: 14px;
  font-weight: 500;
  margin: 0;
`,
);
